import React from 'react';
import WatchToggle from 'src/components/WatchList/WatchToggle';
import { WATCH_LIST_SOURCES } from 'src/constants/analytics';

export interface AGWatchIconProps {
  certificationId: number;
}

const AGWatchIcon: React.FC<AGWatchIconProps> = ({ certificationId }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <WatchToggle
        certificationId={certificationId}
        size="small"
        showError={false}
        showTooltip={true}
        className="ag-watch-icon"
        source={WATCH_LIST_SOURCES.TEAM_RENTERS}
      />
    </div>
  );
};

export default AGWatchIcon;
